import { SET } from '../..';
import { Webshop, WebshopCore } from '@/services';
import {
    WebshopBrand,
    WebshopCategory,
    WebshopMainCategory,
    WebshopProduct,
    CampaignWebshopProduct,
    WebshopProductDetail,
    WebshopSetting,
    WebshopSiteFilter
} from '@/services/models';

export default {
    namespaced: true,
    state: {
        productsDetailsPromises: [],
        salonPickOptions: { dialog: false },
        bundleSalonPickOptions: { dialog: false },
        productsSalonPickOptions: { dialog: false },
        addedToCartDialog: false,
        addedProductsToCartDialog: false,
        selectedSalon: null,
        selectedProduct: null,
        selectedProducts: [],
        totalPagesPagination: 0,
        filteredProductsCount: 0,
        brandsFilter: [],
        siteFilters: [],
        categories: [],
        categoriesFilter: [],
        similarProducts: [],
        searchProducts: [],
        searchProductsBrands: [],
        searchProductsCategories: [],
        products: [],
        productsDetails: [],
        settings: null,
        chainImgLogo: '',
        purchaseHistory: {},
        selectedBundle: null,
        popularProducts: []
    },
    getters: {
        get(state) {
            return key => state[key];
        },

        getBrands(state) {
            return state.products
                .filter((v, i, a) => a.findIndex(t => (t.brandName === v.brandName)) === i)
                .map(b => {
                    return {
                        brandName: b.brandName,
                        series: state.products
                            .filter((v, i, a) => b.brandName === v.brandName && a.findIndex(t => (t.serieName === v.serieName)) === i)
                            .map(p => p.serieName)
                    }
                });
        },

        getSeries(state) {
            return state.products.map(x => x.serieName)
        },

        getProductsByBrand: state => brandName => {
            return state.products.filter(x => x.brandName === brandName)
        },
        getChainLogoUrl(state) {
            return state.settings.chainLogoUrl
        },
        getProducts(state, getters, rootState, rootGetters) {
            var products = state.products
            var activeSites = getters['get']('settings')?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = getters['get']('settings')?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            var newProdArray = []
            products.forEach((p) => {
                var prod = new WebshopProduct(p)
                var addedStock = rootGetters['checkout/cartProduct']({ id: p.id })?.quantity || 0
                prod.productDetails = p.productDetails
                prod.serieName = p.serieName
                prod.idBase64 = p.idBase64
                prod.title = p.title
                prod.urlSafeTitle = p.urlSafeTitle
                prod.videoUrl = p.videoUrl
                prod.imgUrl = p.imgUrl
                prod.brandImgUrl = p.brandImgUrl
                prod.onlineStock = p.onlineStock
                prod.stockForDelivery = p.stockForDelivery
                var onlineStocks = p.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = p.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                var onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                var stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
                prod.onlineStock = (onlineStock > 0 && onlineStock - addedStock === 0) ? -1 : onlineStock - addedStock // -1 if the user has added all available products to cart
                prod.stockForDelivery = stockForDelivery - addedStock
                prod.quantity = addedStock
                newProdArray.push(prod)
            });
            return newProdArray
        }
    },
    actions: {
        set({ commit }, payload) {
            commit('SET', payload);
        },

        async getCategories({ commit }, payload) {
            let response = await Webshop.GetCategories(payload);
            commit('SET', { key: 'categories', value: response.data.Array.map(category => new WebshopMainCategory(category)) });
        },


        async getWebshopSettings({ commit }, params) {
            let response = await Webshop.GetWebshopSettings(params);
            commit('SET', { key: 'settings', value: new WebshopSetting(response.data.Value) });
        },

        async getProducts({ commit, dispatch, state, rootGetters }, params) {
            let response = await Webshop.GetProducts(params);
            let products = response.data.ProductList.map(product => new WebshopProduct(product));
            var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            products.forEach((p) => {
                if (p.productDetails) {
                    let campaign = p.productDetails.campaigns.length > 1 && p.discounts?.length ? p.productDetails.campaigns.find((c) => c.CampaignId == p.discounts[0]?.CampaignId) : p.productDetails.campaigns[0];

                    p.bestCampaign = campaign;
                    p.salePrice = (campaign?.PromotionType === 4 || campaign?.PromotionType == 1) ? p.productDetails.price : p.discounts?.length ? p.discounts[0]?.DiscountPrice : p.productDetails.price;

                    var onlineStocks = p.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                    var shipmentStock = p.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                    p.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                    p.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
                }
            });

            commit('SET', {
                key: 'products',
                value: products
            });

            commit('SET', {
                key: 'categoriesFilter',
                value: response.data.CategoryListFilter.map(category => new WebshopCategory(category))
            });
            commit('SET', { key: 'brandsFilter', value: response.data.BrandListFilter.map(brand => new WebshopBrand(brand)) });
            commit('SET', {
                key: 'siteFilters',
                value: response.data.SiteListFilter.filter(site => state.settings.activatedSalons.map(site => site.siteId).includes(site.Id)).map(site => new WebshopSiteFilter(site)) //response.data.SiteListFilter.map(site => new WebshopSiteFilter(site))
            });
            commit('SET', { key: 'totalPagesPagination', value: response.data.PageCount });
            commit('SET', { key: 'filteredProductsCount', value: response.data.ProductsCount });
        },

        async GetCampaignProducts({ commit, dispatch, state }, params) {
            let response = await Webshop.GetCampaignProducts(params);
            let products = response.data.ProductList.map(product => new WebshopProduct(product));
            var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            products.forEach(prod => {
                let campaignPrice = params.campaignProducts.find(p => p.productId === prod.id).salePrice
                prod.campaignPrice = campaignPrice
                prod.campaignDiscount = prod.productDetails.price != campaignPrice ? Math.round(((prod.productDetails.price - campaignPrice) / prod.productDetails.price) * 100) : null
                var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
            })

            commit('SET', {
                key: 'products',
                value: products
            });


        },

        setProductData({ commit, dispatch, state }, data) {
            commit('SET', {
                key: 'categoriesFilter',
                value: data.CategoryListFilter.map(category => new WebshopCategory(category))
            });
            commit('SET', { key: 'brandsFilter', value: data.BrandListFilter.map(brand => new WebshopBrand(brand)) });
            commit('SET', {
                key: 'siteFilters',
                value: data.SiteListFilter.filter(site => state.settings.activatedSalons.map(site => site.siteId).includes(site.Id)).map(site => new WebshopSiteFilter(site)) //response.data.SiteListFilter.map(site => new WebshopSiteFilter(site))
            });
            commit('SET', { key: 'totalPagesPagination', value: data.PageCount });
            commit('SET', { key: 'filteredProductsCount', value: data.ProductsCount });
        },

        async getProductsByIds({ state, commit, dispatch }, params) {
            let response = await Webshop.GetProductsByIds(params);
            var products = response.data.ProductList.map(product => new WebshopProduct(product));
            var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            var lowestPriceRes = await WebshopCore.GetLowestProductPrice(
                products.map(x => x.idBase64)
              );

            products.forEach(prod => {
                var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
                prod.lowestPrice = lowestPriceRes.data.dto?.find(x => x.productId === prod.id)?.price
                prod.dateOfLowestPrice = lowestPriceRes.data.dto?.find(x => x.productId === prod.id)?.lastDate
            })
            return products;
        },

        async getWebshopBundles({ commit, dispatch }, params) {
            let response = await Webshop.GetWebshopBundlesByIds(params);
            return response.data.Bundles
        },

        async getSimilarProducts({ state, commit, dispatch }, params) {
            let response = await Webshop.GetSimiliarProductsByCategoryId(params);
            let products = response.data.ProductList.map(product => new WebshopProduct(product));
            var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            products.forEach(prod => {
                var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
            })
            if (!products.length) return commit('SET', { key: 'similarProducts', value: [] });
            commit('SET', { key: 'similarProducts', value: products });
        },

        async getProductsBySearchText({ state, commit, dispatch }, params) {
            let response = await Webshop.GetProductsBySearchText(params);
            let products = response.data.ProductList.map(product => new WebshopProduct(product));

            var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
            var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            products.forEach(prod => {
                var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
            })

            commit('SET', { key: 'searchProducts', value: products });
            commit('SET', { key: 'searchProductsBrands', value: response.data.BrandListFilter.map(brand => new WebshopBrand(brand)) });
            commit('SET', { key: 'searchProductsCategories', value: response.data.CategoryListFilter.map(category => new WebshopCategory(category)) });
        },

        async getProductsDetails({ commit, state }, payload) {
            if (!payload.productIds.length) return;
            // let productsMissingDetails = payload.productIds
            // .filter(x => !state.productsDetails.map(pd => pd.id).includes(x) && !state.productsDetailsPromises.includes(x)); // filter products with missing details

            // if (!productsMissingDetails.length) // return in case product ids data is already being fetched and response not returned
            //    return;

            // commit('UPDATE_PRODUCT_DETAILS_PROMISES', productsMissingDetails); // add product ids to promise state

            // payload.productIds = productsMissingDetails; // replace params with filered ids that are already fetched or fetching is in progress

            let response = await Webshop.GetProductsDetails(payload);

            let productDetails = (response.data.Value || []).map(productDetails => new WebshopProductDetail(productDetails));

            if (payload.return) return productDetails;

            // get products that are removed from db but still persist in cache
            let removedProductsIds = payload.productIds.filter(x => !productDetails.map(x => x.id).includes(x));
            commit('UPDATE_PRODUCT_DETAILS', { productDetails, removedProductsIds });
        },

        updateProductInventory({ commit }, { productId, isIncrement, inventory }) {
            commit('UPDATE_PRODUCT_INVENTORY', { productId, isIncrement, inventory })
        },

        async getPopularProducts({ state, commit }, payload) {
            let response = await Webshop.GetPopularProducts(payload);
            let products = []
            if (response.data?.PopularProducts.length) {
                var productIds = response.data?.PopularProducts.map(p => p.ProductId)
                let res = await Webshop.GetProductsByIds({ chainId: payload.chainId, productIds: productIds })
                products = res.data.ProductList.map(x => new WebshopProduct(x));
                var activeSites = state.settings?.activatedSalons.map(s => s.siteId) || []
                var deliverySites = state.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
                products.forEach((p) => {
                    if (p.productDetails) {
                        let campaign = p.productDetails.campaigns.length && p.discounts?.length ? p.productDetails.campaigns.find((c) => c.CampaignId == p.discounts[0]?.CampaignId) : p.productDetails.campaigns[0];

                        p.bestCampaign = campaign;
                        p.salePrice = (campaign?.PromotionType === 4 || campaign?.PromotionType == 1) ? p.productDetails?.price : p.discounts?.length ? p.discounts[0]?.DiscountPrice : p.productDetails.price;

                        var onlineStocks = p.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                        var shipmentStock = p.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                        p.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                        p.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
                    }
                });
            }
            if (!products.length) return commit('SET', { key: 'popularProducts', value: [] });
            commit('SET', { key: 'popularProducts', value: products });
            return products
        }
    },

    mutations: {
        SET,

        'UPDATE_PRODUCT_INVENTORY'(state, { productId, isIncrement, inventory }) {
            const index = state.products.findIndex(item => item.id === productId);
            if (!inventory)
                isIncrement ? state.products[index].inventory-- : state.products[index].inventory++;
            else
                state.products[index].inventory = inventory;
        },

        'UPDATE_PRODUCT_DETAILS'(state, { productDetails, removedProductsIds }) {
            state.products = state.products.filter(x => !removedProductsIds.includes(x.id));

            productDetails.forEach(x => {
                let product = state.products.find(y => x.id === y.id);
                if (product) product.productDetails = x;
            });

            let dataWithoutDuplicates = productDetails.filter(x => !state.productsDetails.map(pd => pd.id).includes(x.id)); // filter out existing product details
            state.productsDetails = state.productsDetails.concat(dataWithoutDuplicates);
        },

        'UPDATE_PRODUCT_DETAILS_PROMISES'(state, data) {
            state.productsDetailsPromises = state.productsDetailsPromises.concat(data);
        }
    }
};
